import type { VoidFunctionComponent } from 'react';

import { ActionsMenu } from './ActionsMenu';
import { PolicyScanButton } from './PolicyScanButton';
import ProjectSummaryV2IssueScanDropdown from './ProjectSummaryV2IssueScanDropdown';

import styles from './ProjectSummaryV2Heading.module.less';

type Props = {
  projectTypeTitle: string;
  revisionLocator?: string;
  baseRevisionURL: string;
  /**
   * While the revision is still building, only the title is shown; the scan
   * picker and action buttons are hidden until the build finishes.
   */
  isBuilding?: boolean;
};

export const ProjectSummaryV2Heading: VoidFunctionComponent<Props> = ({
  projectTypeTitle,
  revisionLocator,
  baseRevisionURL,
  isBuilding,
}) => {
  return (
    <div className={styles.heading}>
      <div>
        <div className={styles.summaryText}>Summary</div>
        <div className={styles.projectTypeTitle}>{projectTypeTitle}</div>
      </div>
      {!isBuilding && (
        <div className={styles.actions}>
          {revisionLocator && <ProjectSummaryV2IssueScanDropdown revisionLocator={revisionLocator} />}
          <ActionsMenu baseRevisionURL={baseRevisionURL} />
          <PolicyScanButton />
        </div>
      )}
    </div>
  );
};
